import React, { useEffect } from 'react'
import BackToTop from '../components/BackToTop'
import Event from '../components/Events/Event'
import Footer from '../components/Footer/Footer'

function Events() {
  useEffect(() => {
    document.title = "Events | IQAPEX Labs";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Explore our latest events, awards, and summits celebrating innovation and sustainability.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Explore our latest events, awards, and summits celebrating innovation and sustainability.";
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div>
      <Event />
      <BackToTop />
      <Footer />
    </div>
  )
}

export default Events
